export const VERSION_APP = "0.13.0-alpha"
export const VERSION_API = 2 // refers to redux-persist version
